import { useEffect, useState, type ReactNode } from 'react';
import { supabase } from '../../lib/supabase';
import { PasswordResetConfirm } from './PasswordResetConfirm';
import { EmailVerifyConfirm } from './EmailVerifyConfirm';

type Mode = 'passthrough' | 'recovery' | 'verified';

const initialHashType = (() => {
  if (typeof window === 'undefined') return null;
  const hash = window.location.hash;
  if (!hash) return null;
  return new URLSearchParams(hash.slice(1)).get('type');
})();

const initialMode: Mode =
  initialHashType === 'recovery' ? 'recovery' :
  initialHashType === 'signup' ? 'verified' :
  'passthrough';

interface Props {
  children: ReactNode;
}

export function AuthRouteHandler({ children }: Props) {
  const [mode, setMode] = useState<Mode>(initialMode);

  useEffect(() => {
    if (!supabase) return;

    const { data } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') {
        setMode('recovery');
      }
    });

    return () => {
      data.subscription.unsubscribe();
    };
  }, []);

  if (mode === 'recovery') {
    return <PasswordResetConfirm onDone={() => setMode('passthrough')} />;
  }

  if (mode === 'verified') {
    return <EmailVerifyConfirm onDone={() => setMode('passthrough')} />;
  }

  return <>{children}</>;
}
